<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader class="object-header">
            <CRow>
                <CCol>
                    <h1 class="page__title">{{ $t(titlePage) }}</h1>
                </CCol>
                <CCol>
                    <ButtonCreate
                        :title="$t('Import deliveries')"
                        @click="
                            $router.push({
                                name: 'delivery_campaigns_import_deliveries_configuration',
                            })
                        "
                    >
                        {{ $t("Import deliveries") }}
                    </ButtonCreate>
                </CCol>
            </CRow>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow class="justify-content-end p-2 m-0">
                    <CCol md="5">
                        <!-- Filter -->
                        <FilterDate @updateData="updateData" />
                    </CCol>
                </CRow>
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterFields
                            :fields="tables.imports.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <!-- Button back -->
                                <div class="d-flex">
                                    <ButtonBack 
                                        class="mr-3"
                                        :to="{
                                            name: 'delivery_campaings',
                                        }" 
                                    />
                                    <TableSettings
                                        :allFields="
                                            tables.imports.allFields
                                        "
                                        :activeFields.sync="
                                            tables.imports.fields
                                        "
                                    />
                                </div>
                            </CCardHeader>
                            <CCardBody>
                                <h6>
                                    {{ $t("leads_received_description") }}
                                </h6>
                                <CCTable
                                    size="sm"
                                    :items="tables.imports.items"
                                    :fields="tables.imports.fields"
                                    :columnFilterValue.sync="
                                        tables.imports.columnFilterValue
                                    "
                                    @update:column-filter-value="updateData()"
                                    @update:sorter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    :items-per-page="tables.imports.rows"
                                    v-bind="tables.imports"
                                    :resizable="true"
                                >
                                    <template #under-table>
                                        <div class="d-flex justify-content-end">
                                            <ButtonExport
                                                :endPoint="
                                                    '/delivery-campaigns/' +
                                                    uuid +
                                                    '/imports'
                                                "
                                                :baseURL="ApiSass"
                                                :adapterFilters="adapterFiltersInExport"
                                                delimiter=";"
                                                stringDelimiter="'"
                                                :table="tables.imports"
                                            />
                                        </div>
                                    </template>
                                    <template #_selected="{ item }">
                                        <CInputRadio
                                            name="_selected"
                                            :checked="
                                                item ===
                                                tables.imports
                                                    .itemSelected
                                            "
                                            @update:checked="
                                                selectItemTable(
                                                    'imports',
                                                    item
                                                )
                                            "
                                        />
                                    </template>
                                </CCTable>
                            </CCardBody>
                            <CCardFooter
                                v-if="tables.imports.total_pages > 0"
                            >
                                <div class="position-relative">
                                    <CPagination
                                        @update:activePage="updatePagination"
                                        :activePage="tables.imports.page"
                                        :pages="tables.imports.total_pages"
                                        align="center"
                                    />
                                    <CElementCover
                                        :opacity="0.8"
                                        class="bg-trasparent"
                                        v-if="tables.imports.loading"
                                    />
                                </div>
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/**
 * Components
 */
import TableSettings from "£lement/TableSettings";
import FilterDate from "~/components/FilterDate";
import FilterFields from "~/components/FilterFields";
import ButtonExport from "~/components/ButtonExport";
import ButtonBack from "£lement/ButtonBack";
import ButtonCreate from "~/components/ButtonCreate";
import CCTable from "~/components/CCTable";

/** Mixins */
import tableMixin from "~/mixins/table.js";
import pageMixin from "~/mixins/page.js";

/** Others */
import {
    cilPlus,
    cilSettings,
    cilPencil,
    cilTrash,
    cilArrowThickFromRight,
} from "@coreui/icons";

import ImportsTable from "./config/tables/Imports";
import { isReservedField } from "../../../utils/tables";

export default {
    name: "DeliveryCampaignsImportsPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],
    components: {
        FilterDate,
        FilterFields,
        TableSettings,
        ButtonBack,
        ButtonExport,
        ButtonCreate,
        CCTable,
    },
    icons: {
        cilPlus,
        cilSettings,
        cilPencil,
        cilTrash,
        cilArrowThickFromRight,
    },
    data() {
        return {
            tables: {
                imports: ImportsTable,
            },
        };
    },
    computed: {
        uuid: function () {
            return this.$route.params.uuid;
        },
    },
    methods: {
        async updateData() {
            await this.updateTable({
                tableName: "imports",
                fetch: {
                    baseURL: process.env.VUE_APP_API_SASS,
                },
                url: `/delivery-campaigns/${this.uuid}/imports`
            });

            this.tables.imports.allFields =
                this.getTableAllFields("imports");
            this.$store.dispatch("page/updateLoading", {
                loading: false,
            });
        },

        adapterFiltersInExport(query) {
            query = {
                ...query,
                fields: this.tables.imports.fields
                    .filter((field) => !isReservedField(field))
                    .map((field) => {
                        return field.key;
                    }),
            };
            return query;
        },
    },
    mounted() {
        this.updateData();
    },
};
</script>

<style scoped lang="scss"></style>
